import React from 'react';

import { useTranslate } from '@src/core/hooks';
import { useOrderDetailsFields } from '@src/features/orders/details/hooks/useOrderDetailsFields';
import type { OrderDetailsCardProps } from '@src/features/orders/details/types';

import { OrderDetailsColumn } from './OrderDetailsColumn';
import {
  OrderDetailsCode,
  OrderDetailsColumns,
  OrderDetailsHeading,
  OrderDetailsRoot,
  OrderDetailsTitle,
} from './styles';

export const OrderDetailsCard = (props: OrderDetailsCardProps) => {
  const { orderCode, buyer, payment, className } = props;
  const { i18n } = useTranslate();
  const { columns } = useOrderDetailsFields({ buyer, payment });

  return (
    <OrderDetailsRoot className={className} data-testid='order-details-card'>
      <OrderDetailsHeading>
        <OrderDetailsTitle>{i18n('checkout_order_details_title')}</OrderDetailsTitle>
        <OrderDetailsCode>{orderCode}</OrderDetailsCode>
      </OrderDetailsHeading>

      <OrderDetailsColumns>
        <OrderDetailsColumn fields={columns[0]} />
        <OrderDetailsColumn fields={columns[1]} />
      </OrderDetailsColumns>
    </OrderDetailsRoot>
  );
};

export default OrderDetailsCard;
